import { OpaSubscription } from '../models/Opa';

const INVALID_ACCESS = 'none';

export const isAuthorized = (subscription: OpaSubscription): boolean => {
  return subscription?.result.access !== INVALID_ACCESS && subscription?.result.restrictions.length !== 0;
};

export const hasProductsEnabled = (subscription: OpaSubscription) => {
  return isAuthorized(subscription);
};
